import { get } from 'lodash';
import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import ActionEditor from 'app/developer-v3/pages/actions/ActionEditor/ActionEditor';
import { currentAction } from 'app/developer-v3/selectors';

const mapStateToProps = state => {
  const action = currentAction(state);

  return {
    currentActionLabel: get(action, ['display', 'label'], ''),
    currentUrl: RouterSelectors.currentUrl(state) || '',
  };
};

export default connect(mapStateToProps)(ActionEditor);
